import React from 'react';
import styles from '../css/comuns/ServicosEssenciais.module.css';
import { config } from '../../data';

const ServicosEssenciais = () => {
  const cards = config.content.servicosEssenciais;
  const images = config.images.servicosEssenciais;

  return (
    <div className={styles['container-custom']}>
      <h2 className={styles['clique']}>{config.texts.servicosEssenciais.title}</h2>
      <div className={styles['cards']}>
        {cards.map((card, index) => (
          <a
            key={index}
            rel="noopener noreferrer"
            href={card.href}
            className={styles['card-custom']}
          >
            <div className={styles['icon']}>
              <img src={images[card.imgKey]} alt={card.text} />
            </div>
            <p className={styles['clique-text']}>{card.text}</p>
          </a>
        ))}
      </div>
    </div>
  );
};

export default ServicosEssenciais;